(function ($) {
	class W4D_Pagination {
		constructor() {
			this.isFetching = false;
			this.initSelectors();
			this.bindEvents();
		}

		initSelectors() {
			this.productsContainer = $('.product-grid, .product-table, .product-list');
			this.pagination = $('.pagination');
			this.paginationPrev = this.pagination.find('a, span').first();
			this.paginationNext = this.pagination.find('a, span').last();
			this.paginationInput = this.pagination.find('input');
			this.paginationTotal = this.pagination.find('label span:last-child');

			// Blog
			this.blogContainer = $('[data-js-posts-container]');

			this.currentPage = parseInt(this.paginationInput.val());
			this.totalPages = parseInt(this.paginationTotal.text());

			if (document.body.classList.contains('search') && document.body.classList.contains('search-results')) {
				this.smoothScrollToTop();
			}
		}

		bindEvents() {
			this.pagination.on('click', 'a', (e) => {
				const $target = $(e.currentTarget);
				if ($target.is(this.paginationNext)) {
					this.handleNextPageClick(e);
				} else if ($target.is(this.paginationPrev)) {
					this.handlePrevPageClick(e);
				}
			});
			this.paginationInput.on('change', (e) => this.handleInputPageChange(e));
			$(document).on('click', '[data-tag]', (e) => this.handleBlogNavClick(e));
			$(document).on('click', '[data-js-pagination="load-more"]', (e) => this.handleLoadMoreClick(e));
			window.addEventListener('popstate', (e) => this.handlePopState(e));
			this.initInfiniteScroll();
		}

		initInfiniteScroll() {
			if (!this.blogContainer.length) {
				return;
			}

			const wrapper = this.blogContainer.find('[data-js-pagination="scroll"]')[0];
			if (!wrapper) {
				return;
			}

			if (this.observer) {
				this.observer.disconnect();
			}

			const options = {
				rootMargin: '400px',
				threshold: 0,
			};

			this.observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting && !this.isFetching) {
						this.fetchNextInfinitePage(wrapper);
					}
				});
			}, options);

			this.observer.observe(wrapper);

			// Scroll restoration
			const savedScroll = sessionStorage.getItem('w4d_scroll_pos');
			if (savedScroll) {
				window.scrollTo(0, parseInt(savedScroll));
				sessionStorage.removeItem('w4d_scroll_pos');
			}

			window.addEventListener('scroll', () => {
				sessionStorage.setItem('w4d_scroll_pos', window.scrollY);
			});
		}

		fetchNextInfinitePage(wrapper) {
			const currentPage = parseInt(wrapper.dataset.currentPage);
			const maxPages = parseInt(wrapper.dataset.maxPages);

			if (currentPage >= maxPages) {
				this.observer.disconnect();
				return;
			}

			this.isFetching = true;
			const loader = wrapper.querySelector('.post-loader');
			if (loader) (loader.classList.add('is-loading'), (loader.style.display = 'block'));

			const activeTag = $('[data-tag][aria-current="true"]').data('tag') || '';
			const category = wrapper.dataset.category || '';
			const layout = wrapper.dataset.layout || '';
			const nextPage = currentPage + 1;

			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: {
					action: 'fetch_posts',
					nonce: w4d_frontend_ajax.nonce,
					tag: activeTag,
					category: category,
					layout: layout,
					paged: nextPage,
				},
				success: (response) => {
					if (response.success) {
						// Find the post list to append to
						const $postList = this.blogContainer.find('ul').first();
						const $newHtml = $(response.data.html);
						const $newItems = $newHtml.is('ul') ? $newHtml.children() : $newHtml;

						if ($postList.length) {
							$postList.append($newItems);
						} else {
							// Fallback for unexpected structure
							this.blogContainer.append($newItems);
						}

						// State Sync
						wrapper.dataset.currentPage = response.data.current_page;

						if (response.data.current_page >= response.data.max_pages) {
							this.observer.disconnect();
						}
					}
				},
				complete: () => {
					this.isFetching = false;
					if (loader) (loader.classList.remove('is-loading'), (loader.style.display = 'none'));
				},
			});
		}

		handleLoadMoreClick(e) {
			e.preventDefault();
			const wrapper = $(e.currentTarget);
			const button = wrapper.find('button');
			const loader = wrapper.find('.post-loader');

			const currentPage = parseInt(wrapper.data('current-page') || 1);
			const maxPages = parseInt(wrapper.data('max-pages') || 1);

			if (this.isFetching || currentPage >= maxPages) return;

			this.isFetching = true;

			const activeTag = $('[data-tag][aria-current="true"]').data('tag') || '';
			const category = wrapper.data('category') || '';
			const layout = wrapper.data('layout') || '';
			const nextPage = currentPage + 1;

			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: {
					action: 'fetch_posts',
					nonce: w4d_frontend_ajax.nonce,
					tag: activeTag,
					category: category,
					layout: layout,
					paged: nextPage,
				},
				beforeSend: () => {
					button.prop('disabled', true);
					loader.show();
				},
				success: (response) => {
					if (response.success) {
						const $postList = this.blogContainer.find('ul').first();
						const $newHtml = $(response.data.html);
						const $newItems = $newHtml.is('ul') ? $newHtml.children() : $newHtml;

						if ($postList.length) {
							$postList.append($newItems);
						} else {
							this.blogContainer.append($newItems);
						}

						// Update state
						wrapper.data('current-page', response.data.current_page);
						wrapper.attr('data-current-page', response.data.current_page);

						if (response.data.current_page >= response.data.max_pages) {
							wrapper.hide();
						}
					}
				},
				complete: () => {
					this.isFetching = false;
					button.prop('disabled', false);
					loader.hide();
				},
			});
		}

		handleBlogNavClick(e) {
			e.preventDefault();
			const clickedLink = $(e.currentTarget);
			const tag = clickedLink.data('tag');
			const $container = this.blogContainer.first();
			const category = $container.attr('data-category') || '';
			const layout = $container.attr('data-layout') || '';

			if (clickedLink.attr('aria-current') === 'true') return;

			// Reset all buttons - set aria-current false and add btn--inverse
			$('[data-tag]').attr('aria-current', 'false').addClass('btn--inverse');

			// Set clicked button as active and remove btn--inverse
			clickedLink.attr('aria-current', 'true').removeClass('btn--inverse');

			$.get({
				url: w4d_frontend_ajax.ajax_url,
				data: {
					action: 'fetch_posts',
					nonce: w4d_frontend_ajax.nonce,
					tag: tag,
					category: category,
					layout: layout,
				},
				beforeSend: () => {
					this.blogContainer.addClass('load');
				},
				success: (response) => {
					if (response.success) {
						this.blogContainer.html(response.data.html);

						const wrapper = this.blogContainer.find('.blog__pagination-wrapper');
						if (wrapper.length) {
							wrapper.attr('data-max-pages', response.data.max_pages);
							wrapper.data('max-pages', response.data.max_pages);
							wrapper.attr('data-current-page', response.data.current_page);
							wrapper.data('current-page', response.data.current_page);
						}

						if (response.data.max_pages <= 1) {
							this.blogContainer.find('.blog__pagination-wrapper').hide();
						} else {
							this.blogContainer.find('.blog__pagination-wrapper').show();
							this.initInfiniteScroll();
						}
					}
				},
				error: (response) => {
					W4D_Toast.showToast('error', 'Došlo je do pogreške');
				},
				complete: () => {
					this.blogContainer.removeClass('load');
				},
			});
		}

		handleNextPageClick(e) {
			e.preventDefault();
			this.handlePageChange(this.currentPage + 1);
		}

		handlePrevPageClick(e) {
			e.preventDefault();
			this.handlePageChange(this.currentPage - 1);
		}

		handleInputPageChange(e) {
			e.preventDefault();
			const pageInput = parseInt(e.target.value);

			if (pageInput >= 1 && pageInput <= this.totalPages) {
				this.handlePageChange(pageInput);
			} else if (pageInput > this.totalPages) {
				// Set input value to max pages if input exceeds total pages
				e.target.value = this.totalPages;
				this.handlePageChange(this.totalPages);
			} else {
				// Keep current page if input is invalid
				e.target.value = this.currentPage;
			}
		}

		handlePageChange(page) {
			if (page >= 1 && page <= this.totalPages) {
				this.updateURL(page);
				if (document.body.classList.contains('page-template-template-news') || document.body.classList.contains('blog')) {
					this.fetchBlogPosts(page);
				} else if (document.body.classList.contains('search') && document.body.classList.contains('search-results')) {
					window.location.href = this.getPaginatedURL(page);
				} else if (document.body.classList.contains('page-template-template-my-products')) {
					this.fetchMyProducts(page);
				} else if (window.location.pathname.includes('naruceni-artikli')) {
					this.fetchNaruceniArtikli(page);
				} else {
					this.fetchProducts(page);
				}
				this.paginationInput.val(page).attr('value', page);
				this.currentPage = page;
				this.updatePaginationLinks();
			}
		}

		handlePopState(event) {
			const page = event.state && event.state.page ? event.state.page : this.getCurrentPageFromURL();
			this.currentPage = page;
			this.paginationInput.val(page).attr('value', page);
			this.updatePaginationLinks();

			if (document.body.classList.contains('page-template-template-news') || document.body.classList.contains('blog')) {
				this.fetchBlogPosts(page);
			} else if (document.body.classList.contains('search') && document.body.classList.contains('search-results')) {
				window.location.reload();
			} else {
				this.fetchProducts(page);
			}
		}

		updateRelNextUrl() {
			let linkNext = document.querySelector("link[rel='next']");
			const nextPage = this.currentPage < this.totalPages ? this.currentPage + 1 : this.totalPages;

			if (!linkNext && nextPage <= this.totalPages) {
				linkNext = document.createElement('link');
				linkNext.setAttribute('rel', 'next');
				linkNext.setAttribute('href', '');
				linkNext.setAttribute('class', 'yoast-seo-meta-tag');

				const canonical = document.querySelector("link[rel='canonical']");
				if (canonical) {
					canonical.after(linkNext);
				} else {
					document.head.appendChild(linkNext);
				}
			}

			const nextUrl = this.getPaginatedURL(nextPage);

			if (linkNext && this.currentPage < this.totalPages) {
				linkNext.setAttribute('href', nextUrl);
			} else if (linkNext) {
				linkNext.remove();
			}
		}

		updateRelPrevUrl() {
			let linkPrev = document.querySelector("link[rel='prev']");
			const prevPage = this.currentPage > 1 ? this.currentPage - 1 : 1;

			if (!linkPrev && this.currentPage > 1) {
				linkPrev = document.createElement('link');
				linkPrev.setAttribute('rel', 'prev');
				linkPrev.setAttribute('href', '');
				linkPrev.setAttribute('class', 'yoast-seo-meta-tag');
				const canonical = document.querySelector("link[rel='canonical']");
				if (canonical) {
					canonical.after(linkPrev);
				} else {
					document.head.appendChild(linkPrev);
				}
			}

			const prevUrl = this.getPaginatedURL(prevPage);

			if (linkPrev) {
				if (this.currentPage > 1) {
					linkPrev.setAttribute('href', prevUrl);
				} else {
					linkPrev.remove();
				}
			}
		}

		updateCanonicalUrl(url) {
			let link = document.querySelector("link[rel='canonical']");
			if (!link) {
				return;
			}
			link.setAttribute('href', url);
		}

		getPaginatedURL(page) {
			const url = new URL(window.location.href);
			// strip any existing /page/n/ segment
			let path = url.pathname.replace(/\/page\/\d+\/?$/, '/');
			// normalize: single leading slash, collapse duplicates, ensure trailing slash
			path = ('/' + path).replace(/\/{2,}/g, '/');
			if (!path.endsWith('/')) path += '/';
			if (page > 1) path += `page/${page}/`;
			url.pathname = path;
			return url.toString();
		}

		updateURL(page) {
			const url = this.getPaginatedURL(page);
			window.history.pushState({ page: page }, '', url);
			this.updateCanonicalUrl(url);
		}

		getCurrentPageFromURL() {
			const pathMatches = window.location.pathname.match(/\/page\/(\d+)\/?/);
			return pathMatches ? parseInt(pathMatches[1]) : 1;
		}

		removePageFromURL() {
			const url = this.getPaginatedURL(1);
			window.history.replaceState({}, '', url);
			this.currentPage = 1;
			this.paginationInput.val(this.currentPage).attr('value', this.currentPage);
		}

		disableFilters(disable) {
			// Handle new popover-based filters
			const $filters = $('.filter');
			$filters.each(function () {
				const $f = $(this);
				const $trigger = $f.find('.filter__trigger');
				const $panel = $f.find('.filter__panel');

				if (disable) {
					$f.addClass('filter--disabled');
					$trigger.prop('disabled', true).attr('tabindex', '-1');

					// Disable all inputs and buttons within the filter panel
					$panel.find('input, button').prop('disabled', true);

					// The popover will stay open during the update.
					// The Popover API's "auto" behavior handles closing when clicking outside.
				} else {
					$f.removeClass('filter--disabled');
					$trigger.prop('disabled', false).removeAttr('tabindex');

					// Re-enable all inputs and buttons within the filter panel
					$panel.find('input, button').prop('disabled', false);
				}
			});

			// Shop archive buttons
			const $archiveButtons = $('.shop-archive__actions button');
			$archiveButtons.prop('disabled', disable);

			$('.filters__reset-all').prop('disabled', disable);
			$('.filters__expand-btn').prop('disabled', disable);
		}

		updateUI(response) {
			if (window.W4D_Filters && typeof window.W4D_Filters.prepareFlip === 'function') {
				window.W4D_Filters.prepareFlip();
			}

			this.productsContainer.toggleClass('load');
			$('.shop-archive__actions-icon').removeClass('shop-archive__actions-icon--disabled');
			this.disableFilters(false);
			this.updateProducts(response.products_html, response.view_type, response.ident_name);
			if (response.page) {
				this.paginationInput.val(response.page).attr('value', response.page);
			}
			this.updatePagination(response.max_num_pages);
			this.updateAvailableFilters(response.available_filters);
			this.updateStockFilters(response.stock_filters);
			this.updateDiscountFilter(response.discount_count);
			this.updateProductCount(response.total_products);
			if (window.W4D_Filters && typeof window.W4D_Filters.updateGlobalResetButtonVisibility === 'function') {
				window.W4D_Filters.updateGlobalResetButtonVisibility();
			}

			if (window.W4D_Filters && typeof window.W4D_Filters.applyFlip === 'function') {
				window.W4D_Filters.applyFlip();
			}
		}

		updateProductCount(count) {
			const $countValue = $('[data-js="product-count-value"]');
			const $countSuffix = $('[data-js="product-count-suffix"]');

			if ($countValue.length && $countSuffix.length) {
				const lastDigit = count % 10;
				const lastTwoDigits = count % 100;
				let suffix = '';

				if (lastDigit === 1 && lastTwoDigits !== 11) {
					suffix = 'artikl';
				} else if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 12 || lastTwoDigits > 14)) {
					suffix = 'artikla';
				} else {
					suffix = 'artikala';
				}

				$countValue.text(count);
				$countSuffix.text(suffix);
			}

			const $footerBtn = $('.js-filters-toggle');
			if (!$footerBtn.length) return;

			let $badge = $footerBtn.find('.filter__badge');

			if (count > 0) {
				if (!$badge.length) {
					$badge = $('<span class="filter__badge" aria-live="polite"></span>');
					$footerBtn.append($badge);
				}
				$badge.text(count).show();
			} else {
				$badge.hide();
			}
		}

		updateAvailableFilters(availableFilters) {
			let allFilters = $('.filters .filter[data-taxonomy]');

			if (allFilters.length === 0) return;

			allFilters.each(function () {
				let $filter = $(this);
				let taxonomy = $filter.data('taxonomy');

				if (availableFilters[taxonomy]) {
					let hasVisibleOptions = false;

					$filter.find('.filter__option').each(function () {
						let $option = $(this);
						let optionValue = $option.data('value');
						let quantity = availableFilters[taxonomy][optionValue] || 0;

						$option.attr('data-qty', quantity);
						$option.find('.filter__quantity').attr('data-qty', quantity);

						if (quantity > 0) {
							hasVisibleOptions = true;
						}
					});

					$filter.attr('aria-hidden', hasVisibleOptions ? 'false' : 'true');

					if (window.W4D_Filters && typeof window.W4D_Filters.updateSearchVisibility === 'function') {
						window.W4D_Filters.updateSearchVisibility($filter);
					}

					if (window.W4D_Filters && typeof window.W4D_Filters.updateVisibleBounds === 'function') {
						window.W4D_Filters.updateVisibleBounds($filter.find('.filter__option'));
					}
				} else {
					if (taxonomy === 'stock_status' || taxonomy === 'discounts') {
						// visibility for these is managed by their own dedicated update methods
						$filter.attr('aria-hidden', 'false');
					} else if (taxonomy !== 'price') {
						$filter.attr('aria-hidden', 'true');
					}
				}
			});
		}

		updateStockFilters(stockFilters) {
			const $stockFilter = $('.filter[data-taxonomy="stock_status"]');

			if (!$stockFilter.length || !stockFilters || typeof stockFilters !== 'object') return;

			$stockFilter.find('.filter__option').each(function () {
				const $option = $(this);
				const val = $option.data('value');
				const count = stockFilters[val] || 0;

				$option.attr('data-qty', count);
				$option.find('.filter__quantity').attr('data-qty', count);
			});

			if (window.W4D_Filters && typeof window.W4D_Filters.updateVisibleBounds === 'function') {
				window.W4D_Filters.updateVisibleBounds($stockFilter.find('.filter__option'));
			}
		}

		updateDiscountFilter(discountCount) {
			const $filter = $('.filter[data-taxonomy="discounts"]');
			if (!$filter.length) return;

			const hasDiscounts = typeof discountCount === 'number' && discountCount > 0;
			$filter.attr('aria-hidden', hasDiscounts ? 'false' : 'true');

			// If the toggle was active but no discounted products remain, silently uncheck
			// and remove the URL param (replaceState — no new history entry, no refetch)
			if (!hasDiscounts && $filter.find('input[type="checkbox"]').is(':checked')) {
				$filter.find('input[type="checkbox"]').prop('checked', false);
				const url = new URL(window.location.href);
				url.searchParams.delete('discounts');
				window.history.replaceState({}, '', url.toString());

				if (window.W4D_Filters && typeof window.W4D_Filters.updateGlobalResetButtonVisibility === 'function') {
					window.W4D_Filters.updateGlobalResetButtonVisibility();
				}
			}
		}

		updateProducts(productsHtml, viewType, ident_name) {
			const isSpecialPage =
				window.location.pathname.includes('naruceni-artikli') ||
				document.body.classList.contains('page-template-template-my-products');

			if (viewType === 'grid') {
				this.productsContainer
					.removeClass('product-table product-list') // Clean up both potential non-grid classes
					.addClass('product-grid')
					.removeAttr('role')
					.html(productsHtml);
			} else {
				// If on a special page, use 'product-list', otherwise default to 'product-table'
				const targetClass = isSpecialPage ? 'product-list' : 'product-table';

				this.productsContainer.removeClass('product-grid').addClass(targetClass).attr('role', 'table').html(productsHtml);
			}
		}

		updatePaginationLinks() {
			// The prev/next <a> and <span> swap clones the icon instead of moving it: moving it is a mutation on the old
			// element, and the focusgroup polyfill's observer then reads .host of that detached <a> (its URL host, a
			// string) and throws "getRootNode is not a function".
			// Compute prev and next page URLs
			const prevPage = this.currentPage > 1 ? this.currentPage - 1 : 1;
			const nextPage = this.currentPage < this.totalPages ? this.currentPage + 1 : this.totalPages;

			// Build URLs
			const prevUrl = this.getPaginatedURL(prevPage);
			const nextUrl = this.getPaginatedURL(nextPage);

			// Handle Prev Button Swapping
			if (this.currentPage > 1) {
				if (this.paginationPrev.is('span')) {
					const $newPrev = $('<a href="' + prevUrl + '" rel="prev" aria-label="Prethodna stranica"></a>').append(
						this.paginationPrev.contents().clone()
					);
					this.paginationPrev.replaceWith($newPrev);
					this.paginationPrev = $newPrev;
				} else {
					this.paginationPrev.attr('href', prevUrl);
					this.paginationPrev.attr('rel', 'prev');
					this.paginationPrev.removeAttr('aria-disabled');
				}
			} else {
				if (this.paginationPrev.is('a')) {
					const $newPrev = $(
						'<span class="icon-placeholder" aria-label="Prethodna stranica" aria-disabled="true"></span>'
					).append(this.paginationPrev.contents().clone());
					this.paginationPrev.replaceWith($newPrev);
					this.paginationPrev = $newPrev;
				}
			}

			// Handle Next Button Swapping
			if (this.currentPage < this.totalPages) {
				if (this.paginationNext.is('span')) {
					const $newNext = $('<a href="' + nextUrl + '" rel="next" aria-label="Sljedeća stranica"></a>').append(
						this.paginationNext.contents().clone()
					);
					this.paginationNext.replaceWith($newNext);
					this.paginationNext = $newNext;
				} else {
					this.paginationNext.attr('href', nextUrl);
					this.paginationNext.attr('rel', 'next');
					this.paginationNext.removeAttr('aria-disabled');
				}
			} else {
				if (this.paginationNext.is('a')) {
					const $newNext = $('<span class="icon-placeholder" aria-label="Sljedeća stranica" aria-disabled="true"></span>').append(
						this.paginationNext.contents().clone()
					);
					this.paginationNext.replaceWith($newNext);
					this.paginationNext = $newNext;
				}
			}

			this.updateRelNextUrl();
			this.updateRelPrevUrl();
		}

		updatePagination(maxNumPages) {
			const previousTotalPages = this.totalPages;

			this.totalPages = maxNumPages;
			this.paginationTotal.text(maxNumPages);
			this.paginationInput.attr('max', maxNumPages);

			// If total pages changed (items per page was changed)
			if (previousTotalPages !== maxNumPages) {
				this.currentPage = 1;
				this.paginationInput.val(1).attr('value', 1);
			}

			if (maxNumPages <= 1) {
				this.pagination.attr('aria-hidden', 'true');
			} else {
				this.pagination.removeAttr('aria-hidden');
			}

			if (this.currentPage > maxNumPages) {
				this.currentPage = maxNumPages;
				this.paginationInput.val(maxNumPages).attr('value', maxNumPages);
			}
			this.updatePaginationLinks();
		}

		smoothScrollToTop(target = false, offset = 180) {
			if (target === false) {
				if ($('.product-grid').length) target = '.product-grid';
				if ($('.product-table').length) target = '.product-table';
				if (target === false) target = '#top';
			}

			const duration = 600; // shorter
			const start = window.pageYOffset;
			const root = document.documentElement;

			const getTargetY = () => {
				let y = 0;
				if (typeof target === 'number') {
					y = target;
				} else {
					const $el = $(target);
					if ($el.length) {
						const $header = $('.w4d-header');
						const headerHeight = $header.length ? $header.outerHeight() : 0;
						y = $el.offset().top - $header.outerHeight();
					}
				}
				return Math.max(0, y - offset);
			};

			const targetY = getTargetY();

			// Skip animation if the scroll is already at or very near the target position
			if (Math.abs(start - targetY) < 100) {
				return;
			}

			const startTime = performance.now();

			// Prevent conflict with CSS scroll-behavior: smooth
			const originalScrollBehavior = root.style.scrollBehavior;
			root.style.scrollBehavior = 'auto';

			const easeInOutQuart = (t) => (t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2);

			const animate = (currentTime) => {
				const elapsed = currentTime - startTime;
				const progress = Math.min(elapsed / duration, 1);
				const easedProgress = easeInOutQuart(progress);

				const currentTargetY = getTargetY();
				const nextY = start + (currentTargetY - start) * easedProgress;

				window.scrollTo(0, nextY);

				if (progress < 1) {
					requestAnimationFrame(animate);
				} else {
					window.scrollTo(0, getTargetY());
					root.style.scrollBehavior = originalScrollBehavior;
				}
			};

			requestAnimationFrame(animate);
		}

		disableShopArchiveHeaderActions() {
			$('.shop-archive__actions-icon').addClass('shop-archive__actions-icon--disabled');
		}

		fetchProducts(pageClick = false) {
			if (document.body.classList.contains('page-template-template-my-products')) {
				return this.fetchMyProducts(pageClick);
			}

			if (window.location.pathname.includes('naruceni-artikli') || document.body.classList.contains('page-naruceni-artikli')) {
				return this.fetchNaruceniArtikli(pageClick);
			}

			if (document.querySelector('[data-js-orders-table]')) {
				return this.fetchPovijestNarudzbi(pageClick);
			}

			const isSearchResult = document.body.classList.contains('search') && document.body.classList.contains('search-results');
			if (isSearchResult) {
				return;
			}

			const searchParm = new URLSearchParams(window.location.search).get('s');

			let { filters, sort, page } = W4D_FrontendHelper.parseUrlParams();

			let taxTerm = this.getCurrentTaxTerm();

			const ajaxData = {
				action: 'w4d_ajax_get_products',
				nonce: w4d_frontend_ajax.nonce,
				taxonomy: taxTerm?.taxonomy,
				termId: taxTerm?.termId,
				filters: JSON.stringify(filters),
				s: searchParm || '',
			};

			if (pageClick) {
				ajaxData.page = page;
				this.paginationInput.val(page).attr('value', page);
			} else {
				this.removePageFromURL();
			}

			$.get({
				url: w4d_frontend_ajax.ajax_url,
				data: ajaxData,
				beforeSend: () => {
					this.productsContainer.toggleClass('load');
					this.disableFilters(true);
					this.disableShopArchiveHeaderActions();
				},
				success: (response) => {
					this.updateUI(response);
					this.smoothScrollToTop();
					if (window.W4D_CarouselInstance) {
						window.W4D_CarouselInstance.init();
					}

					if (window.W4D_ShopCategories) {
						window.W4D_ShopCategories.reinit(this.productsContainer);
					}
				},
				error: (error) => {
					console.error('Error fetching filtered products:', error);
					this.productsContainer.toggleClass('load');
					this.disableFilters(false);
					$('.shop-archive__actions-icon').removeClass('shop-archive__actions-icon--disabled');
				},
			});
		}

		fetchMyProducts(pageClick = false) {
			let { sort, page } = W4D_FrontendHelper.parseUrlParams();

			const ajaxData = {
				action: 'w4d_ajax_get_my_products',
				nonce: w4d_frontend_ajax.nonce,
				sort: sort,
			};

			if (pageClick) {
				ajaxData.paged = page;
				this.paginationInput.val(page).attr('value', page);
			} else {
				this.removePageFromURL();
			}

			$.get({
				url: w4d_frontend_ajax.ajax_url,
				data: ajaxData,
				beforeSend: () => {
					this.productsContainer.toggleClass('load');
				},
				success: (response) => {
					this.updateUI(response);
					this.smoothScrollToTop();
					if (window.W4D_CarouselInstance) {
						window.W4D_CarouselInstance.init();
					}

					if (window.W4D_ShopCategories) {
						window.W4D_ShopCategories.reinit(this.productsContainer);
					}
				},
				error: (error) => {
					console.error('Error fetching filtered products:', error);
					this.productsContainer.toggleClass('load');
				},
			});
		}

		/**
		 * Order history (Povijest narudžbi) - replaces the table with the requested page.
		 * Also used by w4d-orders.js to refresh the current page after (un)archiving an order.
		 */
		fetchPovijestNarudzbi(pageClick = false, { scroll = true } = {}) {
			const $wrapper = $('[data-js-orders-table]');
			if (!$wrapper.length) {
				return;
			}

			const { page } = W4D_FrontendHelper.parseUrlParams();

			const ajaxData = {
				action: 'w4d_ajax_get_povijest_narudzbi',
				nonce: w4d_frontend_ajax.nonce,
				tab: $wrapper.attr('data-tab') || '',
			};

			if (pageClick) {
				ajaxData.paged = page;
			} else {
				this.removePageFromURL();
			}

			// Only the latest request may update the table (fast page clicks, back/forward).
			const requestId = (this.ordersRequestId = (this.ordersRequestId || 0) + 1);
			const isLatestRequest = () => requestId === this.ordersRequestId;

			$.get({
				url: w4d_frontend_ajax.ajax_url,
				data: ajaxData,
				beforeSend: () => {
					$wrapper.addClass('is-loading').attr('aria-busy', 'true');
				},
				success: (response) => {
					if (!isLatestRequest() || !response.success) {
						return;
					}

					const { html, page: renderedPage, max_num_pages: maxNumPages, counts } = response.data;

					$wrapper.find('[data-js-orders-table-content]').html(html);

					if (counts) {
						$('[data-js-orders-count="active"]').text(counts.active);
						$('[data-js-orders-count="archived"]').text(counts.archived);
					}

					if (this.pagination.length) {
						this.updatePagination(maxNumPages);

						// The server clamps out-of-range pages, keep pagination and URL in sync with what was rendered.
						this.currentPage = renderedPage;
						this.paginationInput.val(renderedPage).attr('value', renderedPage);
						this.updatePaginationLinks();

						if (this.getCurrentPageFromURL() !== renderedPage) {
							window.history.replaceState({ page: renderedPage }, '', this.getPaginatedURL(renderedPage));
						}
					}

					this.updatePageBreadcrumb(renderedPage);

					if (scroll) {
						this.smoothScrollToTop('.sidebar__main');
					}
				},
				error: (error) => {
					if (isLatestRequest()) {
						console.error('Error fetching orders:', error);
					}
				},
				complete: () => {
					if (isLatestRequest()) {
						$wrapper.removeClass('is-loading').removeAttr('aria-busy');
					}
				},
			});
		}

		/**
		 * Keeps WooCommerce's breadcrumb in step with an AJAX page change. Rendered on page N it ends with a linked
		 * page crumb and "Stranica N" (WC_Breadcrumb::paged_trail()); on page 1 the page crumb is plain text.
		 */
		updatePageBreadcrumb(page) {
			const $nav = $('.woocommerce-breadcrumb');
			if (!$nav.length) {
				return;
			}

			const $items = $nav.children('.breadcrumb-item');
			const $last = $items.last();
			const hasPageCrumb = /^Stranica\s+\d+$/.test($last.text().trim());
			const $pageCrumb = hasPageCrumb ? $items.eq(-2) : $last;

			if (page > 1) {
				if (hasPageCrumb) {
					$last.text(`Stranica ${page}`);
				} else {
					$nav.append("<span class='delimiter'>\\</span>", $('<span class="breadcrumb-item"></span>').text(`Stranica ${page}`));
				}

				if (!$pageCrumb.children('a').length) {
					const label = $pageCrumb.text();
					$pageCrumb.empty().append($('<a></a>').attr('href', this.getPaginatedURL(1)).text(label));
				}
			} else if (hasPageCrumb) {
				$last.prev('.delimiter').remove();
				$last.remove();
				$pageCrumb.text($pageCrumb.text());
			}
		}

		fetchNaruceniArtikli(pageClick = false) {
			let { sort, page } = W4D_FrontendHelper.parseUrlParams();

			const ajaxData = {
				action: 'w4d_ajax_get_naruceni_artikli',
				nonce: w4d_frontend_ajax.nonce,
				sort: sort,
			};

			if (pageClick) {
				ajaxData.paged = page;
				this.paginationInput.val(page).attr('value', page);
			} else {
				this.removePageFromURL();
			}

			$.get({
				url: w4d_frontend_ajax.ajax_url,
				data: ajaxData,
				beforeSend: () => {
					this.productsContainer.toggleClass('load');
				},
				success: (response) => {
					this.updateUI(response);
					this.smoothScrollToTop();
					if (window.W4D_CarouselInstance) {
						window.W4D_CarouselInstance.init();
					}

					if (window.W4D_ShopCategories) {
						window.W4D_ShopCategories.reinit(this.productsContainer);
					}
				},
				error: (error) => {
					console.error('Error fetching filtered products:', error);
					this.productsContainer.toggleClass('load');
				},
			});
		}

		fetchBlogPosts(page) {
			const activeTag = $('[data-tag][aria-current="true"]').data('tag') || '';
			const $container = this.blogContainer.first();
			const category = $container.attr('data-category') || '';
			const layout = $container.attr('data-layout') || '';

			const ajaxData = {
				action: 'fetch_posts',
				nonce: w4d_frontend_ajax.nonce,
				tag: activeTag,
				category: category,
				layout: layout,
				paged: page,
			};

			$.get({
				url: w4d_frontend_ajax.ajax_url,
				data: ajaxData,
				beforeSend: () => {
					this.blogContainer.addClass('load');
				},
				success: (response) => {
					this.blogContainer.html(response.data.html);
					this.paginationInput.val(page).attr('value', page);
				},
				error: (error) => {
					console.error('Error fetching blog posts:', error);
				},
				complete: () => {
					this.smoothScrollToTop();
					this.blogContainer.removeClass('load');
				},
			});
		}

		getCurrentTaxTerm() {
			const classes = document.body.className.split(/\s+/);

			// Find tax-{taxonomy}
			const taxMatch = classes.find((cls) => cls.startsWith('tax-'));
			if (!taxMatch) return null;

			const taxonomy = taxMatch.replace('tax-', '');

			// Find term-{ID} (numeric ending)
			const termIdMatch = classes.find((cls) => cls.startsWith('term-') && cls.match(/term-\d+$/));
			const termId = termIdMatch ? termIdMatch.match(/term-(\d+)/)[1] : 0;

			return {
				taxonomy: taxonomy,
				termId: parseInt(termId),
			};
		}
	}

	$(document).ready(function () {
		window.W4D_Pagination = new W4D_Pagination();
	});
})(jQuery);
